'use client';

/**
 * Mount-only: initializes Sentry once for the (app) route group. Mirrors
 * lib/analytics/AnalyticsProvider.tsx exactly. (app)-only; never import
 * from `(marketing)/**` (eslint.config.mjs no-restricted-imports wall).
 */
import { useEffect } from 'react';
import { initErrorMonitoring } from './sentry';

export function SentryProvider(): null {
  useEffect(() => {
    initErrorMonitoring();
  }, []);
  return null;
}
